import React, {
  Fragment,
  useEffect,
  // useMemo,
  useState
} from "react";
import Day from "./Day";
import "./Calendar.css";
import moment from "moment";
import { useAuth } from "../../context/AuthContext";
import List from "../../components/ListLocation";
import { MdOutlineClose } from "react-icons/md";
import {
  getAllFacilityOrgList,
  getAllNurseOrgList,
  getOrganizationDetails,
} from "../../api_url/organizationTable";
import {
  // getCustomerId,
  getCustomerTableList,
} from "../../api_url/customerTable";
import AutoCompleteManager from "./AutoCompleteManager";
import { postJobTable } from "../../api_url/jobTable";
import { postFacilityNotification } from "../../api_url/facilityNotification";
import { postNurseNotification } from "../../api_url/nurseNotification";
import { socket } from "../../api_url/socket";
import { sendNotification } from "../../api_url/webNotification";
import { createNurse } from "../../api_url/nurseTable";
import AutoCompleteCustomer from "./AutoCompleteCustomer";
import * as pdfjs from "pdfjs-dist/webpack";
import "pdfjs-dist/web/pdf_viewer.css"; // Import styles if needed
import { fetchScheduleData } from "../../utils/function";
import { Dialog, Transition } from "@headlessui/react";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const Calendar = () => {
  const { authToken, userId } = useAuth();

  const [check, setCheck] = useState(false);
  const [loading, setLoading] = useState(true);
  const [aiLoading, setAiLoading] = useState(false);
  const [reRender, setReRender] = useState(false);
  const [loadingScreen, setLoadingScreen] = useState(true);
  const [calendarGrid, setCalendarGrid] = useState([]);
  const [orgLocation, setOrgLocation] = useState("");
  const [orgLocationId, setOrgLocationId] = useState([]);
  const [orgLocationIdValue, setOrgLocationIdValue] = useState("");
  const [file, setFile] = useState("");
  const [orgLocationIdValueList, setOrgLocationIdValueList] = useState({
    name: "Select location Id"
  });
  const [customer, setCustomer] = useState(undefined);
  const [loadingScreenManager, setLoadingScreenManager] = useState(true);
  const [customerList, setCustomerList] = useState(undefined);
  const [managerList, setManagerList] = useState(undefined);
  const [nurseList, setNurseList] = useState(undefined);
  const [managerId, setManagerId] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [shiftData, setShiftData] = useState(undefined);
  const [extractedText, setExtractedText] = useState("");
  const [orgLocationIdAddress, setOrgLocationIdAddress] = useState([]);
  const [processData, setProcessData] = useState(false);
  const [successAlert, setSuccessAlert] = useState(false);

  // Get the current date
  const currentDate = new Date();

  // Subtract 18 years from the current date
  const date18YearsAgo = new Date(
    currentDate.getFullYear() - 18,
    currentDate.getMonth(),
    currentDate.getDate()
  );

  const [nurseData, setNurseData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    password: "",
    phoneNumber: "",
    gender: "",
    dateOfBirth: date18YearsAgo,
    primaryState: "",
    fullAddress: "",
    latitude: "",
    longitude: "",
    organization: "",
    location_id: "",
    primaryLicenseType: "",
    primaryLicenseMultiPrivilege: false,
    clinicalLicenseNumber: "",
    clinicalLicenseExpirationDate: new Date(),
    nurseVerified: false,
    emailVerified: false,
    nurseLoginControl: false,
    nurseAppAccessControl: false
  });

  const handleInputChangeNewData = (event) => {
    setNurseData((prevState) => {
      return { ...prevState, [event.target.name]: event.target.value };
    });
  };

  const validateNurseFields = (data) => {
    let isValid = true;
    const emptyFields = [];

    const email = data?.email;
    const firstName = data?.firstName;
    const lastName = data?.lastName;
    const password = data?.password;
    const phoneNumber = data?.phoneNumber;
    const gender = data?.gender;
    const fullAddress = data?.fullAddress;
    const primaryLicenseType = data?.primaryLicenseType;

    if (
      firstName === "" ||
      lastName === "" ||
      password === "" ||
      email === "" ||
      phoneNumber === "" ||
      gender === "" ||
      primaryLicenseType === "" ||
      fullAddress === ""
    ) {
      isValid = false;

      if (firstName === "") {
        emptyFields.push("First Name is missing");
      }
      if (lastName === "") {
        emptyFields.push("Last Name is missing");
      }
      if (password === "") {
        emptyFields.push("Password is missing");
      }
      if (fullAddress === "") {
        emptyFields.push("Address is missing");
      }
      if (email === "") {
        emptyFields.push("Email is missing");
      }
      if (phoneNumber === "") {
        emptyFields.push("Phone Number is missing");
      }
      if (primaryLicenseType === "") {
        emptyFields.push("License Type is missing");
      }
      if (gender === "") {
        emptyFields.push("gender is missing");
      }
    }

    return {
      isValid,
      emptyFields
    };
  };

  const postNurse = async (setAddRecord) => {
    const validationResult = validateNurseFields(nurseData);
    if (validationResult.isValid) {
      let state = orgLocationIdAddress?.find(
        (i) => i?.location === orgLocationIdValue
      );
      try {
        await createNurse(authToken, {
          email: nurseData?.email,
          firstName: nurseData?.firstName,
          lastName: nurseData?.lastName,
          password: nurseData?.password,
          phoneNumber: nurseData?.phoneNumber,
          gender: nurseData?.gender,
          dateOfBirth: nurseData?.dateOfBirth,
          primaryState: state?.state,
          fullAddress: nurseData?.fullAddress,
          latitude: nurseData?.latitude.toString(),
          longitude: nurseData?.longitude.toString(),
          location_id: orgLocationIdValue,
          organization: orgLocation,
          primaryLicenseType: nurseData?.primaryLicenseType,
          primaryLicenseMultiPrivilege: nurseData?.primaryLicenseMultiPrivilege,
          clinicalLicenseNumber: nurseData?.clinicalLicenseNumber,
          clinicalLicenseExpirationDate:
            nurseData?.clinicalLicenseExpirationDate,
          nurseVerified: nurseData?.emailVerified,
          emailVerified: nurseData?.emailVerified
        })
          .then((res) => {
            alert(
              res?.firstName + " " + res?.lastName + " created successfully."
            );
            managerList?.map(async (item) => {
              await postFacilityNotification(
                authToken,
                item?.id,
                "",
                "New employee joined!",
                `${
                  res?.firstName + " " + res?.lastName
                } has been added as a new employee to your location.`,
                "ManageUser",
                {},
                false,
                false,
                "green",
                ""
              );
              socket?.emit("tableNotificationInsert", {
                table: "FacilityNotificationTable",
                id: item?.id
              });
              if (item?.mobileId) {
                sendNotification(authToken, {
                  expoPushToken: item?.mobileId,
                  title: "New employee joined!",
                  body: `${
                    res?.firstName + " " + res?.lastName
                  } has been added as a new employee to your location.`,
                  data: { screen: "ManageUser" }
                });
              }
            });
            setNurseData({
              email: "", //
              firstName: "", //
              lastName: "", //
              password: "", //
              phoneNumber: "", //
              gender: "", //
              dateOfBirth: date18YearsAgo, //
              primaryState: "", //
              fullAddress: "",
              latitude: "",
              longitude: "",
              organization: "", //
              location_id: "", //
              primaryLicenseType: "", //
              primaryLicenseMultiPrivilege: false, //
              clinicalLicenseNumber: "", //
              clinicalLicenseExpirationDate: new Date(), //
              nurseVerified: false, //
              emailVerified: false, //,
              nurseLoginControl: false,
              nurseAppAccessControl: false
            });
            setAddRecord(false);
            getLocationJobList(orgLocationIdValue, orgLocation);
          })
          .catch((e) => {
            // console.log(e)
            alert(e);
          });
      } catch (error) {
        console.log("data save error:", error);
      }
    } else {
      alert(
        validationResult.emptyFields +
          (validationResult.emptyFields.length > 1
            ? validationResult.emptyFields.length ===
              validationResult.emptyFields.length - 1
              ? ","
              : ""
            : "") +
          ". Please enter a value."
      );
    }
  };

  function GetDateMergedTime(date, time) {
    const date1 = moment(date).format("YYYY-MM-DD");
    const time1 = moment(time).format("hh:mm a");
    const mergedTime = moment(`${date1} ${time1}`, `YYYY-MM-DD hh:mm a`);
    return mergedTime;
  }

  function timeDifferent(sTime, eTime) {
    // Parse the start and end times
    const startTime = moment(sTime, "hh:mm A");
    const endTime = moment(eTime, "hh:mm A");

    // Handle cases where endTime is past midnight
    if (endTime.isBefore(startTime)) {
      endTime.add(1, "day");
    }

    // Calculate the duration
    const duration = moment.duration(endTime.diff(startTime));
    const hours = Math.floor(duration.asHours());
    const minutes = duration.minutes();

    // Format the result
    const onlyHours = `${hours}${hours === 1 ? " hour" : " hours"}${
      minutes > 0 ? ` ${minutes} minutes` : ""
    }`;

    return onlyHours;
  }

  const currentYear = new Date().getFullYear();
  const mData = [
    { month: "January", totalDays: 31 },
    {
      month: "February",
      totalDays:
        currentYear % 100 === 0
          ? currentYear % 400 === 0
          : currentYear % 4 === 0
          ? 28
          : 29
    },
    { month: "March", totalDays: 31 },
    { month: "April", totalDays: 30 },
    { month: "May", totalDays: 31 },
    { month: "June", totalDays: 30 },
    { month: "July", totalDays: 31 },
    { month: "August", totalDays: 31 },
    { month: "September", totalDays: 30 },
    { month: "October", totalDays: 31 },
    { month: "November", totalDays: 30 },
    { month: "December", totalDays: 31 }
  ];

  useEffect(() => {
    if (extractedText !== "" && aiLoading && reRender !== null) {
      fetchScheduleData(extractedText)
        .then((res) => {
          // console.log(res);
          if (res?.data[0]?.month) {
            const sMonth = mData.filter(
              (i) =>
                i.month.toLocaleLowerCase() ===
                  res?.data[0]?.month?.toLocaleLowerCase() && i
            );

            if (res?.data?.length === sMonth[0]?.totalDays) {
              console.log("Correct");
              setShiftData(res);
            } else {
              console.log("In-Correct");
              setReRender(true);
            }
            // setShiftData(res);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [aiLoading, extractedText, reRender]);

  const extractTextFromPdf = async (file) => {
    const reader = new FileReader();
    reader.onload = async (event) => {
      const pdfUrl = event.target.result;
      const loadingTask = pdfjs.getDocument(pdfUrl);
      try {
        const pdf = await loadingTask.promise;
        const numPages = pdf.numPages;
        let fullText = "";

        for (let i = 1; i <= numPages; i++) {
          const page = await pdf.getPage(i);
          const textContent = await page.getTextContent();
          const pageText = textContent.items
            .map((item) => item.str + "\n")
            .join(""); // Add line breaks
          fullText += pageText;
        }
        // console.log(fullText);
        setExtractedText(fullText);
      } catch (error) {
        console.error("Error extracting text:", error);
      }
    };
    reader.readAsDataURL(file);
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      extractTextFromPdf(file);
      setFile(file?.name);
      setAiLoading(true);
    }
  };

  function areNamesEqual(name1, name2) {
    // Convert to lowercase and trim whitespace
    let formattedName1 = name1?.toLowerCase()?.trim();
    let formattedName2 = name2?.toLowerCase()?.trim();

    // Split names into arrays of words and sort them
    let nameArray1 = formattedName1?.split(" ")?.sort();
    let nameArray2 = formattedName2?.split(" ")?.sort();

    // Compare the sorted arrays
    return nameArray1?.join(" ") === nameArray2?.join(" ");
  }

  const handleProcessData = () => {
    const currentYear = new Date().getFullYear();

    const sMonth = shiftData?.data[0]?.month;
    const sDate = shiftData?.data[0]?.date;
    const eMonth = shiftData?.data[shiftData?.data.length - 1]?.month;
    const eDate = shiftData?.data[shiftData?.data.length - 1]?.date;

    const startDate = new Date(`${sMonth} ${sDate} ${currentYear}`);
    const endDate = new Date(`${eMonth} ${eDate} ${currentYear}`);

    setStartDate(startDate);

    const totalDays =
      Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

    const firstDayOfWeek = startDate.getDay();
    // console.log(totalDays, firstDayOfWeek);

    const daysArray = Array.from(
      { length: firstDayOfWeek + totalDays },
      (_, i) => {
        const dayIndex = i - firstDayOfWeek;
        return dayIndex >= 0 ? shiftData?.data[dayIndex] : null;
      }
    );
    const getLicenseType = (name) => {
      if (name?.toLocaleLowerCase() === "registered nurse") {
        return "RN";
      } else if (name?.toLocaleLowerCase() === "home health aide") {
        return "HHA";
      } else if (name?.toLocaleLowerCase() === "licensed practical nurse") {
        return "LPN";
      } else {
        let li = name.split("-");
        return li[0];
      }
    };
    const enhancedDaysArray = daysArray.map((shift) => {
      if (shift) {
        const fullDate = new Date(
          `${shift.month} ${shift.date} ${currentYear}`
        );
        const [startTime, endTime] = shift.shift_1.time
          ?.split("-")
          .map((time) => time.trim());
        const [startTime2, endTime2] = shift.shift_2.time
          ?.split("-")
          .map((time) => time.trim());

        const dateStr = moment(
          new Date(`${shift.month} ${shift.date} ${currentYear}`)
        ).format("YYYY-MM-DD");

        // Function to merge date and time, and get the hour
        function getHourFromDateTime(dateStr, timeStr) {
          const dateTimeStr = `${dateStr} ${timeStr}`;
          const dateTime = new Date(dateTimeStr);
          if (isNaN(dateTime)) {
            console.error("Invalid date format");
            return null;
          }
          const hour = dateTime.getHours();
          return hour;
        }

        // Usage example
        const hour = getHourFromDateTime(dateStr, startTime);
        const hour2 = getHourFromDateTime(dateStr, startTime2);

        let jobTiming =
          hour >= 5 && hour < 12
            ? "Morning"
            : hour >= 12 && hour < 17
            ? "Afternoon"
            : hour >= 17 && hour < 20
            ? "Evening"
            : "Night";
        let jobTiming2 =
          hour2 >= 5 && hour2 < 12
            ? "Morning"
            : hour2 >= 12 && hour2 < 17
            ? "Afternoon"
            : hour2 >= 17 && hour2 < 20
            ? "Evening"
            : "Night";

        return {
          ...shift,
          fullDate: fullDate.toDateString(), // or use any format you prefer
          shift_1: {
            ...shift.shift_1,
            shiftTitle:
              customer?.firstName +
              " " +
              customer?.lastName +
              "-" +
              shift.shift_1.name +
              "-Job Title",
            startDate: moment(new Date(fullDate.toDateString())).format(
              "YYYY-MM-DD"
            ),
            endDate: moment(new Date(fullDate.toDateString())).format(
              "YYYY-MM-DD"
            ),
            startTime: new Date(
              `${moment(new Date(fullDate.toDateString())).format(
                "MM-DD-YYYY"
              )} ${startTime}`
            ),
            endTime: new Date(
              `${moment(new Date(fullDate.toDateString())).format(
                "MM-DD-YYYY"
              )} ${endTime}`
            ),
            break: "No Break",
            customerName: customer?.firstName + " " + customer?.lastName,
            customerId: customer?.id,
            fullAddress: customer?.fullAddress,
            latitude: customer?.latitude,
            longitude: customer?.longitude,
            jobType: "Shift",
            jobTiming: jobTiming,
            customerVisibility: true,
            jobPostingTableFacilityTableId: managerId,
            licenseTypeArr: [getLicenseType(shift.shift_1.role)],
            jobFinalNurseTableId: "",
            jobFinalNurseTable: undefined
          },
          shift_2: {
            ...shift.shift_2,
            shiftTitle:
              customer?.firstName +
              " " +
              customer?.lastName +
              "-" +
              shift.shift_2.name +
              "-Job Title",
            startDate: moment(new Date(fullDate.toDateString())).format(
              "YYYY-MM-DD"
            ),
            endDate: moment(new Date(fullDate.toDateString())).format(
              "YYYY-MM-DD"
            ),
            startTime: new Date(
              `${moment(new Date(fullDate.toDateString())).format(
                "MM-DD-YYYY"
              )} ${startTime2}`
            ),
            endTime: new Date(
              `${moment(new Date(fullDate.toDateString())).format(
                "MM-DD-YYYY"
              )} ${endTime2}`
            ),
            break: "No Break",
            customerName: customer?.firstName + " " + customer?.lastName,
            customerId: customer?.id,
            fullAddress: customer?.fullAddress,
            latitude: customer?.latitude,
            longitude: customer?.longitude,
            jobType: "Shift",
            jobTiming: jobTiming2,
            customerVisibility: true,
            jobPostingTableFacilityTableId: managerId,
            licenseTypeArr: [getLicenseType(shift.shift_2.role)],
            jobFinalNurseTableId: "",
            jobFinalNurseTable: undefined
          }
        };
      }
      return shift;
    });

    // Update the state only if the grid has changed
    setCalendarGrid((prevGrid) => {
      const prevGridString = JSON.stringify(prevGrid);
      const newGridString = JSON.stringify(enhancedDaysArray);
      return prevGridString !== newGridString ? enhancedDaysArray : prevGrid;
    });
    setAiLoading(false);
    setProcessData(false);
    setReRender(null);
  };

  useEffect(() => {
    if (customer !== undefined && managerId !== "" && shiftData !== undefined) {
      if (
        areNamesEqual(
          shiftData?.customer?.replace(/,/g, ""),
          customer?.firstName + " " + customer?.lastName
        )
      ) {
        handleProcessData();
      } else {
        // if (
        //   // eslint-disable-next-line no-restricted-globals
        //   confirm(
        //     "The Patient name on the upload file does not match the selected patient name. Please check and re-upload the correct file."
        //   ).valueOf(true)
        // ) {
        //   const currentYear = new Date().getFullYear();

        //   const sMonth = shiftData?.data[0]?.month;
        //   const sDate = shiftData?.data[0]?.date;
        //   const eMonth = shiftData?.data[shiftData?.data.length - 1]?.month;
        //   const eDate = shiftData?.data[shiftData?.data.length - 1]?.date;

        //   const startDate = new Date(`${sMonth} ${sDate} ${currentYear}`);
        //   const endDate = new Date(`${eMonth} ${eDate} ${currentYear}`);

        //   setStartDate(startDate);

        //   const totalDays =
        //     Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

        //   const firstDayOfWeek = startDate.getDay();
        //   // console.log(totalDays, firstDayOfWeek);

        //   const daysArray = Array.from(
        //     { length: firstDayOfWeek + totalDays },
        //     (_, i) => {
        //       const dayIndex = i - firstDayOfWeek;
        //       return dayIndex >= 0 ? shiftData?.data[dayIndex] : null;
        //     }
        //   );
        //   const getLicenseType = (name) => {
        //     if (name?.toLocaleLowerCase() === "registered nurse") {
        //       return "RN";
        //     } else if (name?.toLocaleLowerCase() === "home health aide") {
        //       return "HHA";
        //     } else if (
        //       name?.toLocaleLowerCase() === "licensed practical nurse"
        //     ) {
        //       return "LPN";
        //     } else {
        //       let li = name.split("-");
        //       return li[0];
        //     }
        //   };
        //   const enhancedDaysArray = daysArray.map((shift) => {
        //     if (shift) {
        //       const fullDate = new Date(
        //         `${shift.month} ${shift.date} ${currentYear}`
        //       );
        //       const [startTime, endTime] = shift.shift_1.time
        //         ?.split("-")
        //         .map((time) => time.trim());
        //       const [startTime2, endTime2] = shift.shift_2.time
        //         ?.split("-")
        //         .map((time) => time.trim());

        //       const dateStr = moment(
        //         new Date(`${shift.month} ${shift.date} ${currentYear}`)
        //       ).format("YYYY-MM-DD");

        //       // Function to merge date and time, and get the hour
        //       function getHourFromDateTime(dateStr, timeStr) {
        //         const dateTimeStr = `${dateStr} ${timeStr}`;
        //         const dateTime = new Date(dateTimeStr);
        //         if (isNaN(dateTime)) {
        //           console.error("Invalid date format");
        //           return null;
        //         }
        //         const hour = dateTime.getHours();
        //         return hour;
        //       }

        //       // Usage example
        //       const hour = getHourFromDateTime(dateStr, startTime);
        //       const hour2 = getHourFromDateTime(dateStr, startTime2);

        //       let jobTiming =
        //         hour >= 5 && hour < 12
        //           ? "Morning"
        //           : hour >= 12 && hour < 17
        //           ? "Afternoon"
        //           : hour >= 17 && hour < 20
        //           ? "Evening"
        //           : "Night";
        //       let jobTiming2 =
        //         hour2 >= 5 && hour2 < 12
        //           ? "Morning"
        //           : hour2 >= 12 && hour2 < 17
        //           ? "Afternoon"
        //           : hour2 >= 17 && hour2 < 20
        //           ? "Evening"
        //           : "Night";

        //       return {
        //         ...shift,
        //         fullDate: fullDate.toDateString(), // or use any format you prefer
        //         shift_1: {
        //           ...shift.shift_1,
        //           shiftTitle:
        //             customer?.firstName +
        //             " " +
        //             customer?.lastName +
        //             "-" +
        //             shift.shift_1.name +
        //             "-Job Title",
        //           startDate: moment(new Date(fullDate.toDateString())).format(
        //             "YYYY-MM-DD"
        //           ),
        //           endDate: moment(new Date(fullDate.toDateString())).format(
        //             "YYYY-MM-DD"
        //           ),
        //           startTime: new Date(
        //             `${moment(new Date(fullDate.toDateString())).format(
        //               "MM-DD-YYYY"
        //             )} ${startTime}`
        //           ),
        //           endTime: new Date(
        //             `${moment(new Date(fullDate.toDateString())).format(
        //               "MM-DD-YYYY"
        //             )} ${endTime}`
        //           ),
        //           break: "No Break",
        //           customerName: customer?.firstName + " " + customer?.lastName,
        //           customerId: customer?.id,
        //           fullAddress: customer?.fullAddress,
        //           latitude: customer?.latitude,
        //           longitude: customer?.longitude,
        //           jobType: "Shift",
        //           jobTiming: jobTiming,
        //           customerVisibility: true,
        //           jobPostingTableFacilityTableId: managerId,
        //           licenseTypeArr: [getLicenseType(shift.shift_1.role)],
        //           jobFinalNurseTableId: "",
        //           jobFinalNurseTable: undefined
        //         },
        //         shift_2: {
        //           ...shift.shift_2,
        //           shiftTitle:
        //             customer?.firstName +
        //             " " +
        //             customer?.lastName +
        //             "-" +
        //             shift.shift_2.name +
        //             "-Job Title",
        //           startDate: moment(new Date(fullDate.toDateString())).format(
        //             "YYYY-MM-DD"
        //           ),
        //           endDate: moment(new Date(fullDate.toDateString())).format(
        //             "YYYY-MM-DD"
        //           ),
        //           startTime: new Date(
        //             `${moment(new Date(fullDate.toDateString())).format(
        //               "MM-DD-YYYY"
        //             )} ${startTime2}`
        //           ),
        //           endTime: new Date(
        //             `${moment(new Date(fullDate.toDateString())).format(
        //               "MM-DD-YYYY"
        //             )} ${endTime2}`
        //           ),
        //           break: "No Break",
        //           customerName: customer?.firstName + " " + customer?.lastName,
        //           customerId: customer?.id,
        //           fullAddress: customer?.fullAddress,
        //           latitude: customer?.latitude,
        //           longitude: customer?.longitude,
        //           jobType: "Shift",
        //           jobTiming: jobTiming2,
        //           customerVisibility: true,
        //           jobPostingTableFacilityTableId: managerId,
        //           licenseTypeArr: [getLicenseType(shift.shift_2.role)],
        //           jobFinalNurseTableId: "",
        //           jobFinalNurseTable: undefined
        //         }
        //       };
        //     }
        //     return shift;
        //   });

        //   // Update the state only if the grid has changed
        //   setCalendarGrid((prevGrid) => {
        //     const prevGridString = JSON.stringify(prevGrid);
        //     const newGridString = JSON.stringify(enhancedDaysArray);
        //     return prevGridString !== newGridString
        //       ? enhancedDaysArray
        //       : prevGrid;
        //   });
        //   setAiLoading(false);
        //   setReRender(null);
        // } else {
        //   window.location.reload();
        // }
        setProcessData(true);
      }
    }
  }, [customer, managerId, shiftData]);

  const handleUpdate = (event) => {
    const { index, name, value } = event;
    const newData = [...calendarGrid];
    newData[index][name] = value;
    setCalendarGrid(newData);
  };

  // console.log(calendarGrid);

  const getOrgLocationList = async () => {
    await getOrganizationDetails(authToken, userId)
      .then((res) => {
        let arr = [];
        let arrState = [];
        // console.log(res)
        if (res) {
          setOrgLocation(res.organizationName);
          res?.locations.map((i) =>
            arr.push({
              name: i.location_id
            })
          );
          if (res?.locations.length === arr.length) {
            // console.log(arr);
            setOrgLocationId(arr);
            setLoadingScreen(false);
          }
          res?.locations.map((i) =>
            arrState.push({
              location: i.location_id,
              state: i.location_state
            })
          );
          if (res?.locations.length === arrState.length) {
            // console.log(arrState);
            setOrgLocationIdAddress(arrState);
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  // const getCustomer = async (location, organization, name) => {
  //   setLoading(true);
  //   try {
  //     const response = await getCustomerId(authToken, name);
  //     setCustomer(response);
  //     const cList = await getCustomerTableList(
  //       authToken,
  //       location,
  //       organization
  //     );

  //     setLoading(false);
  //   } catch (error) {
  //     console.log(error);
  //     setLoading(false);
  //   }
  // };

  const getLocationJobList = async (location, organization) => {
    setLoadingScreenManager(true);
    try {
      const managerData = await getAllFacilityOrgList(
        authToken,
        location,
        organization
      );
      const nurseData = await getAllNurseOrgList(
        authToken,
        location,
        organization
      );
      const customerData = await getCustomerTableList(
        authToken,
        location,
        organization
      );

      setManagerList(managerData);
      setNurseList(nurseData);
      setCustomerList(customerData);
      setLoadingScreenManager(false);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  // console.log(managerList, nurseList);

  useEffect(() => {
    getOrgLocationList();
  }, [authToken, userId]);

  useEffect(() => {
    if (orgLocationIdValue !== "" && orgLocation !== "") {
      // getCustomer(orgLocationIdValue, orgLocation, shiftData.customer);
      getLocationJobList(orgLocationIdValue, orgLocation);
    }
  }, [orgLocationIdValue]);

  // function handleFileUpload(event) {
  //   const file = event.target.files[0];
  //   setFile(file.name);
  // }

  const validateFields = () => {
    const newData = [...calendarGrid];
    const invalidRows = [];

    for (let i = 0; i < newData.length; i++) {
      const data = newData[i];
      const jobFinalNurseTableId =
        data?.shift_1?.jobFinalNurseTableId?.toString();
      const jobFinalNurseTableId2 =
        data?.shift_2?.jobFinalNurseTableId?.toString();

      const jobFinalNurseTable =
        !data?.shift_1?.jobFinalNurseTable?.nurseLoginControl ||
        data?.shift_1?.jobFinalNurseTable?.nurseAppAccessControl ||
        !data?.shift_1?.jobFinalNurseTable?.availableDate ||
        !data?.shift_1?.jobFinalNurseTable?.availableTime;
      const jobFinalNurseTable2 =
        !data?.shift_2?.jobFinalNurseTable?.nurseLoginControl ||
        data?.shift_2?.jobFinalNurseTable?.nurseAppAccessControl ||
        !data?.shift_2?.jobFinalNurseTable?.availableDate ||
        !data?.shift_2?.jobFinalNurseTable?.availableTime;

      if (
        jobFinalNurseTableId === "" ||
        jobFinalNurseTableId2 === "" ||
        jobFinalNurseTable ||
        jobFinalNurseTable2
      ) {
        // console.log(data);
        invalidRows.push(data);
      }
    }
    let returnNull = invalidRows?.filter((i) => i !== null && i);
    // console.log(returnNull.length, returnNull);
    if (returnNull.length === 0) {
      setCheck(true);
    } else {
      alert("Fill all required fields!");
      setCheck(false);
    }
  };

  async function send(mobileId, jobType, jobFinalNurseTableId) {
    if (mobileId) {
      sendNotification(authToken, {
        expoPushToken: mobileId,
        title: `“Direct ${jobType}s Assignment” (Check Upcoming Jobs)`,
        body: `${jobType}s assigned.`,
        data: { screen: "NotificationScreen" }
      });
    }
    await postNurseNotification(
      authToken,
      jobFinalNurseTableId,
      "",
      `“Direct ${jobType}s Assignment” (Check Upcoming Jobs)`,
      `${jobType}s assigned.`,
      "HomeScreen",
      {
        screen: "UpComing"
      },
      false,
      false,
      "green",
      ""
    );
    socket?.emit("tableNotificationInsert", {
      table: "NurseNotificationTable",
      id: jobFinalNurseTableId
    });
    socket?.emit("tableJobInsert", {
      table: "JobPostingTable",
      message: "Fetch Dashboard Job"
    });
  }

  const publishData = async () => {
    const promises = calendarGrid
      ?.filter((i) => i !== null)
      // .splice(0, 1)
      ?.map(async (day) => {
        // console.log(day);
        // console.log(
        //   authToken,
        //   day?.shift_1?.licenseTypeArr,
        //   day?.shift_1?.shiftTitle,
        //   "",
        //   [],
        //   "",
        //   "0",
        //   day?.shift_1?.startDate,
        //   day?.shift_1?.endDate,
        //   day?.shift_1?.startTime.toString(),
        //   day?.shift_1?.endTime.toString(),
        //   "No Break",
        //   day?.shift_1?.customerName,
        //   day?.shift_1?.customerId.toString(),
        //   "",
        //   "",
        //   day?.shift_1?.fullAddress,
        //   day?.shift_1?.latitude.toString(),
        //   day?.shift_1?.longitude.toString(),
        //   "1",
        //   false,
        //   "",
        //   "Shift",
        //   "Nurse Assigned",
        //   day?.shift_1?.jobFinalNurseTableId?.toString(),
        //   "",
        //   [day?.shift_1?.jobFinalNurseTableId],
        //   false,
        //   "",
        //   "",
        //   "",
        //   "",
        //   "",
        //   "",
        //   "",
        //   "",
        //   "",
        //   "",
        //   "",
        //   timeDifferent(day?.shift_1?.startTime, day?.shift_1?.endTime),
        //   day?.shift_1?.jobTiming,
        //   "",
        //   [],
        //   "",
        //   "",
        //   "",
        //   "",
        //   "",
        //   "",
        //   "",
        //   false,
        //   false,
        //   false,
        //   false,
        //   false,
        //   false,
        //   "",
        //   "",
        //   {},
        //   "",
        //   managerId?.toString(),
        //   false,
        //   "",
        //   "",
        //   "",
        //   false,
        //   false,
        //   "",
        //   "",
        //   "",
        //   "",
        //   "",
        //   "",
        //   "",
        //   "",
        //   day?.shift_1?.startTime?.valueOf()?.toString(),
        //   "",
        //   "",
        //   "",
        //   "",
        //   orgLocation,
        //   orgLocationIdValue
        // );
        const shift_1 = await postJobTable(
          authToken,
          day?.shift_1?.licenseTypeArr,
          day?.shift_1?.shiftTitle,
          "",
          [],
          "",
          "0",
          day?.shift_1?.startDate,
          day?.shift_1?.endDate,
          day?.shift_1?.startTime.toString(),
          day?.shift_1?.endTime.toString(),
          "No Break",
          day?.shift_1?.customerName,
          day?.shift_1?.customerId.toString(),
          "",
          "",
          day?.shift_1?.fullAddress,
          day?.shift_1?.latitude.toString(),
          day?.shift_1?.longitude.toString(),
          "1",
          false,
          "",
          "Shift",
          "Nurse Assigned",
          day?.shift_1?.jobFinalNurseTableId?.toString(),
          "",
          [day?.shift_1?.jobFinalNurseTableId],
          false,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          timeDifferent(day?.shift_1?.startTime, day?.shift_1?.endTime),
          day?.shift_1?.jobTiming,
          "",
          [],
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          false,
          false,
          false,
          false,
          false,
          false,
          "",
          "",
          {},
          "",
          managerId?.toString(),
          false,
          "",
          "",
          "",
          false,
          false,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          day?.shift_1?.startTime?.valueOf()?.toString(),
          "",
          "",
          "",
          "",
          orgLocation,
          orgLocationIdValue
        );
        const nurse1 = nurseList.flat().filter((item) => {
          return (
            parseInt(item?.id) === parseInt(day?.shift_1?.jobFinalNurseTableId)
          );
        });
        send(nurse1[0]?.mobileId, shift_1?.jobType, nurse1[0]?.id);
        // console.log(
        //     authToken,
        //     day?.shift_2?.licenseTypeArr,
        //     day?.shift_2?.shiftTitle,
        //     "",
        //     [],
        //     "",
        //     "0",
        //     day?.shift_2?.startDate,
        //     day?.shift_2?.endDate,
        //     day?.shift_2?.startTime.toString(),
        //     day?.shift_2?.endTime.toString(),
        //     "No Break",
        //     day?.shift_2?.customerName,
        //     day?.shift_2?.customerId.toString(),
        //     "",
        //     "",
        //     day?.shift_2?.fullAddress,
        //     day?.shift_2?.latitude.toString(),
        //     day?.shift_2?.longitude.toString(),
        //     "1",
        //     false,
        //     "",
        //     "Shift",
        //     "Nurse Assigned",
        //     day?.shift_2?.jobFinalNurseTableId?.toString(),
        //     "",
        //     [day?.shift_2?.jobFinalNurseTableId],
        //     false,
        //     "",
        //     "",
        //     "",
        //     "",
        //     "",
        //     "",
        //     "",
        //     "",
        //     "",
        //     "",
        //     "",
        //     timeDifferent(day?.shift_2?.startTime, day?.shift_2?.endTime),
        //     day?.shift_2?.jobTiming,
        //     "",
        //     [],
        //     "",
        //     "",
        //     "",
        //     "",
        //     "",
        //     "",
        //     "",
        //     false,
        //     false,
        //     false,
        //     false,
        //     false,
        //     false,
        //     "",
        //     "",
        //     {},
        //     "",
        //     managerId?.toString(),
        //     false,
        //     "",
        //     "",
        //     "",
        //     false,
        //     false,
        //     "",
        //     "",
        //     "",
        //     "",
        //     "",
        //     "",
        //     "",
        //     "",
        //     day?.shift_2?.startTime?.valueOf()?.toString(),
        //     "",
        //     "",
        //     "",
        //     "",
        //     orgLocation,
        //     orgLocationIdValue
        //   );
        const shift_2 = await postJobTable(
          authToken,
          day?.shift_2?.licenseTypeArr,
          day?.shift_2?.shiftTitle,
          "",
          [],
          "",
          "0",
          day?.shift_2?.startDate,
          day?.shift_2?.endDate,
          day?.shift_2?.startTime.toString(),
          day?.shift_2?.endTime.toString(),
          "No Break",
          day?.shift_2?.customerName,
          day?.shift_2?.customerId.toString(),
          "",
          "",
          day?.shift_2?.fullAddress,
          day?.shift_2?.latitude.toString(),
          day?.shift_2?.longitude.toString(),
          "1",
          false,
          "",
          "Shift",
          "Nurse Assigned",
          day?.shift_2?.jobFinalNurseTableId?.toString(),
          "",
          [day?.shift_2?.jobFinalNurseTableId],
          false,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          timeDifferent(day?.shift_2?.startTime, day?.shift_2?.endTime),
          day?.shift_2?.jobTiming,
          "",
          [],
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          false,
          false,
          false,
          false,
          false,
          false,
          "",
          "",
          {},
          "",
          managerId?.toString(),
          false,
          "",
          "",
          "",
          false,
          false,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          day?.shift_2?.startTime?.valueOf()?.toString(),
          "",
          "",
          "",
          "",
          orgLocation,
          orgLocationIdValue
        );
        const nurse2 = nurseList.flat().filter((item) => {
          return (
            parseInt(item?.id) === parseInt(day?.shift_2?.jobFinalNurseTableId)
          );
        });
        send(nurse2[0]?.mobileId, shift_1?.jobType, nurse2[0]?.id);

        return Promise.all([shift_1, shift_2]);
      });

    await Promise.all(promises);
    setSuccessAlert(true);
  };

  return (
    <div>
      {loadingScreen ? (
        <div className="flex-1">
          <div className="flex justify-center items-center mt-10">
            Loading....
          </div>
        </div>
      ) : (
        <div className="flex-1">
          <div className="flex justify-between m-5 items-center">
            <div>
              <div className="flex flex-row items-center justify-center">
                <div className="flex items-center">
                  <List
                    data={orgLocationIdValueList}
                    handleInputChangeNewData={(item) => {
                      setOrgLocationIdValue(item);
                      setOrgLocationIdValueList({
                        name: "Location Id - " + item
                      });
                    }}
                    options={orgLocationId}
                  />
                  {orgLocationIdValue !== "" && (
                    <MdOutlineClose
                      onClick={() => {
                        setFile("");
                        setCheck(false);
                        setManagerId("");
                        setShiftData(undefined);
                        setCustomer(undefined);
                        setCustomerList(undefined);
                        setCalendarGrid([]);
                        setManagerList(undefined);
                        setOrgLocationIdValue("");
                        setOrgLocationIdValueList({
                          name: "Select location Id"
                        });
                      }}
                      className="ml-2 text-xl cursor-pointer"
                    />
                  )}
                </div>
                <div className="ml-2">
                  {!loadingScreenManager && managerList !== undefined && (
                    <AutoCompleteManager
                      jobNewData={managerId}
                      handleInputChangeNewData={(event) => setManagerId(event)}
                      option={managerList?.sort((a, b) =>
                        a.firstName
                          .toLowerCase()
                          .localeCompare(b.firstName.toLowerCase())
                      )}
                      color={true}
                    />
                  )}
                </div>
                <div className="ml-2">
                  {!loadingScreenManager && managerList !== undefined && (
                    <AutoCompleteCustomer
                      jobNewData={customer}
                      handleInputChangeNewData={(event) => setCustomer(event)}
                      option={customerList?.sort((a, b) =>
                        a.firstName
                          .toLowerCase()
                          .localeCompare(b.firstName.toLowerCase())
                      )}
                      color={true}
                    />
                  )}
                </div>
              </div>
            </div>
            {orgLocationIdValue !== "" && (
              <div className="flex">
                <div
                  className={`relative w-full rounded-lg
                ${
                  file !== ""
                    ? "bg-gray-500 cursor-not-allowed"
                    : "bg-blue-500 cursor-pointer"
                }
                 py-2 px-5 shadow-md focus:outline-none
                  focus-visible:border-indigo-500 focus-visible:ring-2
                   focus-visible:ring-white/75 focus-visible:ring-offset-2
                    focus-visible:ring-offset-orange-300 sm:text-sm
                    text-white font-medium text-center items-center`}
                >
                  <span className="text-center text-base">Planing</span>
                </div>
                <div
                  className={`relative w-full rounded-lg
                 ${
                   file === ""
                     ? "bg-orange-300 cursor-not-allowed"
                     : file !== "" && !check
                     ? "bg-orange-500 cursor-pointer"
                     : "bg-gray-500 cursor-not-pointer"
                 } py-2 px-5 shadow-md focus:outline-none
                  focus-visible:border-indigo-500 focus-visible:ring-2
                   focus-visible:ring-white/75 focus-visible:ring-offset-2
                    focus-visible:ring-offset-orange-300 sm:text-sm
                    text-white font-medium text-center items-center ml-5`}
                  onClick={() => validateFields()}
                >
                  <span className="text-center text-base">Review</span>
                </div>
                <div
                  className={`relative w-full rounded-lg
                  ${
                    file === ""
                      ? "bg-gray-500 cursor-not-allowed"
                      : "bg-red-500 cursor-pointer"
                  } 
                  py-2 px-5 shadow-md focus:outline-none
                  focus-visible:border-indigo-500 focus-visible:ring-2
                   focus-visible:ring-white/75 focus-visible:ring-offset-2
                    focus-visible:ring-offset-orange-300 sm:text-sm
                    text-white font-medium text-center items-center mx-5`}
                  onClick={() => {
                    setFile("");
                    setManagerId("");
                    setShiftData(undefined);
                    setCustomer(undefined);
                    setCustomerList(undefined);
                    setCheck(false);
                    setCalendarGrid([]);
                    setManagerList(undefined);
                    setOrgLocationIdValue("");
                    setOrgLocationIdValueList({
                      name: "Select location Id"
                    });
                  }}
                >
                  <span className="text-center text-base">Cancel</span>
                </div>
              </div>
            )}
          </div>
          {orgLocationIdValue === "" ? (
            <div className="flex justify-center items-center mt-10">
              Select Location Id
            </div>
          ) : loading ? (
            <div className="flex justify-center items-center mt-10">
              Loading....
            </div>
          ) : managerId === "" ? (
            <div className="flex justify-center items-center mt-10">
              Select Manager
            </div>
          ) : customer === undefined ? (
            <div className="flex justify-center items-center mt-10">
              Select customer
            </div>
          ) : file === "" ? (
            <div>
              <div
                className="flex mt-2 items-center mx-5
                    justify-center bg-grey-lighter"
              >
                <label
                  className="flex flex-col items-center px-28 py-6 
           bg-white text-blue rounded-lg shadow-lg tracking-wide uppercase border
            border-blue cursor-pointer hover:bg-blue"
                >
                  <svg
                    className="mx-auto h-24 w-24 text-gray-200"
                    viewBox="0 0 400 460"
                    fill="currentColor"
                  >
                    <path d="M398.286284,360.544249 C393.676808,343.190601 377.828429,331.089442 359.696758,331.078584 L359.696758,331.078584 C341.370574,330.889056 325.342643,343.255751 321.059352,360.889742 L309.821446,360.889742 C298.820948,360.889742 289.871322,351.634464 289.871322,340.752403 L289.871322,280.204163 C293.719701,274.22515 296.899751,267.849313 299.354613,261.190172 L313.986035,261.190172 C356.709227,261.238541 391.382544,227.00309 391.431421,184.724549 C391.462344,158.050472 377.460349,133.284506 354.473815,119.354206 C354.727182,116.428369 354.906733,113.476867 354.906733,110.272661 C354.926683,49.3907725 305.070324,0.0197424893 243.54813,-5.71751646e-06 C221.863342,-0.00690987124 200.648379,6.24948498 182.504738,18.0012017 C167.058354,28.0609871 154.347132,41.7237768 145.491272,57.7872532 C141.97606,57.4160944 138.441895,57.230515 134.906733,57.2315021 C115.356608,57.2028755 96.3471322,63.5856223 80.8518703,75.3827468 C66.8418953,86.0219742 56.1935162,100.398455 50.1586035,116.822232 C43.278803,120.404506 36.9785536,124.983777 31.4653367,130.407039 C1.21995012,160.29618 1.18603491,208.789657 31.3895262,238.720258 C45.919202,253.119442 65.6428928,261.203991 86.2054863,261.190172 L100.836908,261.190172 C103.291771,267.849313 106.47182,274.22515 110.3202,280.204163 L110.3202,340.752403 C110.3202,351.638412 101.370574,360.889742 90.3700748,360.889742 L79.1321696,360.889742 C74.8488778,343.255751 58.8209476,330.889056 40.4947631,331.078584 C18.4438903,331.091416 0.578553616,348.790558 0.591514142,370.611931 C0.603491272,392.433305 18.4897756,410.112704 40.5406484,410.099871 C58.6743142,410.09 74.5236908,397.987854 79.1331671,380.632232 L90.3710723,380.632232 C112.37207,380.632232 130.271322,362.520472 130.271322,340.752403 L130.271322,303.397639 C146.988529,317.973519 167.939152,326.937597 190.121696,329.005622 L190.121696,381.48412 C168.785037,386.936009 155.954115,408.472103 161.463342,429.586695 C166.972569,450.701288 188.735162,463.39867 210.07182,457.946781 C231.408479,452.494893 244.239401,430.958798 238.730175,409.844206 C235.101247,395.936609 224.126683,385.075279 210.07182,381.48412 L210.07182,329.005622 C232.254364,326.938584 253.204988,317.974506 269.922195,303.398627 L269.922195,340.752403 C269.922195,362.524421 287.821446,380.632232 309.822444,380.632232 L321.060349,380.632232 C326.666334,401.735966 348.497756,414.347468 369.823441,408.799828 C391.14813,403.253176 403.892269,381.647983 398.286284,360.544249 Z M40.4947631,390.108627 C29.4763092,390.108627 20.5446384,381.269914 20.5446384,370.366137 C20.5446384,359.462361 29.4763092,350.623648 40.4947631,350.623648 C51.513217,350.623648 60.4448878,359.462361 60.4448878,370.366137 C60.4319202,381.263991 51.5072319,390.095794 40.4947631,390.108627 Z M94.1855362,224.652747 C94.2054863,230.277382 94.6643392,235.892146 95.5571072,241.447702 L86.2054863,241.447702 C54.476808,241.473348 28.7351621,216.041073 28.7092062,184.642618 C28.6962594,169.53073 34.7640898,155.035794 45.5720698,144.360043 C50.4947631,139.547811 56.2314214,135.626953 62.5226933,132.774163 L66.5356608,130.92133 L67.838404,126.733948 C76.9476309,97.4351073 104.527681,76.9739914 134.906733,76.9739914 C139.697756,76.9552361 144.4798,77.3954936 149.185037,78.2888412 L156.885786,79.8129614 L160.189526,72.7619313 C167.461347,57.1890558 178.986534,43.9369099 193.463342,34.4990129 C235.732668,7.14579399 292.405985,18.8797425 320.046883,60.7091416 C329.784539,75.4449356 334.966584,92.6712446 334.958603,110.277597 C334.892768,114.393906 334.613466,118.504292 334.121696,122.591974 L333.309726,130.622232 L339.457357,133.665536 C367.888279,147.588927 379.529177,181.684206 365.459352,209.819227 C355.772569,229.188584 335.824439,241.447702 313.986035,241.447702 L304.634414,241.447702 C305.526185,235.892146 305.983042,230.277382 306.001995,224.652747 C306.001995,166.769742 258.585536,119.846781 200.093766,119.846781 C141.601995,119.846781 94.1855362,166.769742 94.1855362,224.652747 Z M220.045885,419.722361 C220.045885,430.626137 211.114214,439.46485 200.095761,439.46485 C189.077307,439.46485 180.145636,430.626137 180.145636,419.722361 C180.145636,408.818584 189.077307,399.979871 200.095761,399.979871 C211.108229,399.992704 220.032918,408.824506 220.045885,419.722361 Z M200.095761,309.730043 C152.622444,309.730043 114.137656,271.645794 114.137656,224.666567 C114.137656,177.687339 152.622444,139.60309 200.095761,139.60309 C247.569077,139.60309 286.053865,177.687339 286.053865,224.666567 C286,271.624077 247.547132,309.676738 200.095761,309.730043 Z M359.696758,390.108627 C348.678304,390.108627 339.746633,381.269914 339.746633,370.366137 C339.746633,359.462361 348.678304,350.623648 359.696758,350.623648 C370.715212,350.623648 379.646883,359.462361 379.646883,370.366137 C379.633915,381.263991 370.709227,390.095794 359.696758,390.108627 Z M238.288279,208.791631 L206.891771,179.875794 C203.062344,176.348798 197.129177,176.348798 193.299751,179.875794 L161.903242,208.791631 C157.870324,212.50618 157.64389,218.752704 161.396509,222.743648 C165.150125,226.734592 171.462344,226.95867 175.495262,223.245107 L190.120698,209.774807 L190.120698,262.231588 C190.120698,267.683476 194.586534,272.102833 200.095761,272.102833 C205.604988,272.102833 210.070823,267.683476 210.070823,262.231588 L210.070823,209.77382 L224.696259,223.24412 C228.729177,226.95867 235.041397,226.734592 238.795012,222.742661 C242.547631,218.751717 242.321197,212.50618 238.288279,208.791631 Z" />
                  </svg>
                  {file === "" ? (
                    <span className="mt-2 text-base leading-normal">
                      Select a file
                    </span>
                  ) : (
                    <span className="mt-2 text-base leading-normal">
                      Selected file - {file}
                    </span>
                  )}
                  <p className="mt-1 text-xs text-gray-500">.pdf</p>
                  <p></p>
                  <input
                    type="file"
                    accept=".pdf"
                    onChange={handleFileUpload}
                    className="hidden"
                  />
                </label>
              </div>
            </div>
          ) : aiLoading ? (
            <div className="flex flex-col justify-center items-center mt-10">
              Processing...
              <div class="flex items-center justify-center my-3">
                <div class="relative">
                  <div class="h-20 w-20 rounded-full border-t-8 border-b-8 border-gray-200"></div>
                  <div class="absolute top-0 left-0 h-20 w-20 rounded-full border-t-8 border-b-8 border-blue-500 animate-spin"></div>
                </div>
              </div>
              It may take a while to process the information. Please be
              patient..
            </div>
          ) : (
            <div>
              <h1 className="text-center text-2xl font-medium">
                {moment(startDate).format("MMMM YYYY")} -{" "}
                {customer?.firstName + " " + customer?.lastName}
              </h1>
              <div className="flex flex-wrap justify-start">
                {calendarGrid.map((shift, index) => (
                  <div key={index} className="calendar-cell">
                    {shift ? (
                      <Day
                        index={index}
                        shiftData={shift}
                        authToken={authToken}
                        orgLocation={orgLocation}
                        orgLocationIdValue={orgLocationIdValue}
                        fullAddress={customer?.fullAddress}
                        latitude={customer?.latitude}
                        longitude={customer?.longitude}
                        customerName={
                          customer?.firstName + " " + customer?.lastName
                        }
                        customerId={customer?.id}
                        handleUpdate={handleUpdate}
                        nurseData={nurseData}
                        setNurseData={setNurseData}
                        date18YearsAgo={date18YearsAgo}
                        handleInputChangeNewData={handleInputChangeNewData}
                        postNurse={postNurse}
                      />
                    ) : (
                      <div className="empty-cell"></div>
                    )}
                  </div>
                ))}
              </div>
              <div className="flex justify-end items-end">
                {check && (
                  <div
                    className={`rounded-lg bg-green-500 cursor-pointer
                  py-2 px-5 shadow-md focus:outline-none
                  focus-visible:border-indigo-500 focus-visible:ring-2
                   focus-visible:ring-white/75 focus-visible:ring-offset-2
                    focus-visible:ring-offset-orange-300 sm:text-sm
                    text-white font-medium text-center m-5 mx-10`}
                    onClick={() => publishData()}
                  >
                    <span className="text-center text-base">Publish</span>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      )}

      <Transition.Root show={processData} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={(e) => setProcessData(e)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-base font-semibold leading-6 text-gray-900"
                        >
                          The patient is different
                        </Dialog.Title>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            The Patient name on the upload file does not match
                            the selected patient name. Please check and
                            re-upload the correct file.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                    <button
                      type="button"
                      className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2
                       text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                      onClick={() => handleProcessData()}
                    >
                      Proceed Anyway
                    </button>
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm 
                      font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                      onClick={() => window.location.reload()}
                    >
                      Cancel
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      <Transition.Root show={successAlert} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={(e) => setSuccessAlert(e)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel
                  className="relative transform overflow-hidden
                 rounded-lg bg-white text-left shadow-xl transition-all
                  sm:my-8 sm:w-full sm:max-w-lg"
                >
                  <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="sm:flex sm:items-start">
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <Dialog.Title
                          as="h3"
                          className="text-base font-semibold leading-6 text-gray-900"
                        >
                          Success
                        </Dialog.Title>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            All shifts have been pushed successfully.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse
                   sm:px-6"
                  >
                    <button
                      type="button"
                      className="inline-flex w-full justify-center rounded-md bg-blue-600 px-3 py-2
                       text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto"
                      onClick={() => window.location.reload()}
                    >
                      OK
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </div>
  );
};

export default Calendar;
